import SynchronizeWacAttachmentResult from 'owa-service/lib/contract/SynchronizeWacAttachmentResult';
import synchronizeWacAttachmentOperation from 'owa-service/lib/operation/synchronizeWacAttachmentOperation';
import * as trace from 'owa-trace';
import RequestOptions from 'owa-service/lib/RequestOptions';

export enum SyncWacResult {
    Success,
    Busy,
    Failed,
}

export default async function synchronizeWacAttachment(
    attachmentId: string,
    requestOptions: RequestOptions
): Promise<SyncWacResult> {
    try {
        const response = await synchronizeWacAttachmentOperation(
            { AttachmentId: attachmentId },
            requestOptions
        );
        switch (response.Result) {
            case SynchronizeWacAttachmentResult.Success:
                return SyncWacResult.Success;
            case SynchronizeWacAttachmentResult.StillEditing:
                return SyncWacResult.Busy;
            default:
                trace.errorThatWillCauseAlert(
                    'synchronizeWacAttachment: unexpected value of SynchronizeWacAttachmentResult'
                );
                return SyncWacResult.Failed;
        }
    } catch (error) {
        trace.trace.warn('synchronizeWacAttachment failed');
        return SyncWacResult.Failed;
    }
}
